<script setup lang="ts">
import { useSaveElemental } from '~~/src/composables/mutations/elemetal/useSaveElemental'
import type { ElementalTypeEnum } from '~~/src/types/elemental'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'

const props = defineProps<Props>()

defineOptions({
  name: 'SaveElementalMenuItem',
})

interface Props {
  id?: string
  elementalType: ElementalTypeEnum
  listId?: string
}

const { mutate, isPending } = useSaveElemental()

const handlerChange = async () => {
  if (!props.id)
    return
  mutate({
    id: props.id,
    elementalType: props.elementalType,
    listId: props.listId,
  })
}
</script>

<template>
  <DropdownMenuItem :disabled="isPending" @select="handlerChange">
    <div i-material-symbols:bookmark w-3 h-3 />
    Add Save
  </DropdownMenuItem>
</template>
